import { getOptanonCategoryClass, ONETRUST_CATEGORIES } from 'libs/oneTrust';
import { SchemaProps } from 'libs/contentful/types';

const Schema = ({ jsonLd }: SchemaProps) => {
  return (
    jsonLd && (
      <script
        className={getOptanonCategoryClass(ONETRUST_CATEGORIES.STRICTLY_NECESSARY)}
        type="application/ld+json"
        data-testid="seoMetadataSchema">
        {JSON.stringify(jsonLd)}
      </script>
    )
  );
};

export default Schema;
